// @flow
import React from 'react';
import { connect } from 'react-redux';
import getDomainRecommendations from 'app/common/react/components/growth/unauth/lib/EmailUtils';
import type { State as ReduxState } from 'app/common/redux/reducers/types';
import { type Dispatch } from 'redux';
import { Box, Text } from 'gestalt';

const styles = {
  emailSuggestionDropdown: {
    border: '1px solid rgb(181, 181, 181)',
    zIndex: 1,
  },
};

type OwnProps = {|
  email: string,
  emailFieldElement: ?HTMLElement,
  showUsername?: boolean,
  handleEmailSuggestionClick: (string) => void,
|};

type ReduxStateProps = {|
  country: string,
|};

type DispatchProps = {|
  dispatch: Dispatch<any>,
|};

type Props = {|
  ...DispatchProps,
  ...OwnProps,
  ...ReduxStateProps,
|};

export const EmailDomainSuggestions = (props: Props) => {
  const { country, email, emailFieldElement, handleEmailSuggestionClick, showUsername } = props;

  const domainSuggestions = getDomainRecommendations(country);

  // Calculating the width of the email suggestion dropdown by either:
  // getting the width of the email text field or taking the width of the window and subtracting the padding
  let width = window.innerWidth - 32;
  const emailFieldRef = emailFieldElement;
  if (emailFieldRef) {
    width = emailFieldRef.getBoundingClientRect().width;
  }

  return (
    <Box
      color="white"
      dangerouslySetInlineStyle={{ __style: styles.emailSuggestionDropdown }}
      direction="column"
      display="flex"
      position="absolute"
      width={width}
    >
      {domainSuggestions.map((domain: string) => {
        const fullEmailSuggestion = (email || '').concat(domain);
        const suggestion = showUsername ? fullEmailSuggestion : domain;
        return (
          <Box key={suggestion}>
            <div
              role="button"
              onMouseDown={() => {
                handleEmailSuggestionClick(fullEmailSuggestion);
              }}
              tabIndex={0}
            >
              <Box paddingX={3} paddingY={2}>
                <Text>{suggestion}</Text>
              </Box>
            </div>
          </Box>
        );
      })}
    </Box>
  );
};

const mapStateToProps = ({ viewer }: ReduxState): ReduxStateProps => ({
  country: viewer.country || '',
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(EmailDomainSuggestions);
